import { PageHero } from '@/components/PageHero'
import { company } from '@/config/company'
import { fakeMoneyNotes, safetyTips } from '@/config/content'
import styles from './ContentPage.module.css'

export function InfoPage() {
  return (
    <>
      <PageHero title="Bilgilendirme" subtitle={company.legalName} />
      <section className={styles.section}>
        <div className={`container ${styles.prose}`}>
          <p className={styles.brandName}>{company.name}</p>
          <h2 className={styles.legalTitle}>{company.legalName}</h2>
          <h2>Güvenliğiniz İçin</h2>
          <ol className={styles.list}>
            {safetyTips.map((tip) => (
              <li key={tip}>{tip}</li>
            ))}
          </ol>

          <h2>Sahte Para</h2>
          <p>
            Gerçek banknotlar; rölyef baskı, filigran, güvenlik şeridi, renk değiştiren mürekkep ve
            ultraviyole özellikler gibi emniyet unsurlarıyla donatılmıştır. Şüpheli banknotları
            orijinaliyle karşılaştırarak inceleyiniz.
          </p>
          <ul className={styles.list}>
            {fakeMoneyNotes.map((note) => (
              <li key={note}>{note}</li>
            ))}
          </ul>
        </div>
      </section>
    </>
  )
}
